function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
import { getViewConfigContinuousSize } from '../../config';
import { hasDiscreteDomain } from '../../scale';
import { getFirstDefined } from '../../util';
import { isSignalRef, isVgRangeStep } from '../../vega.schema';
import { signalOrStringValue } from '../common';
import { isFacetModel } from '../model';
export function assembleLayoutSignals(model) {
  return [].concat(_toConsumableArray(sizeSignals(model, 'width')), _toConsumableArray(sizeSignals(model, 'height')), _toConsumableArray(sizeSignals(model, 'childWidth')), _toConsumableArray(sizeSignals(model, 'childHeight')));
}
export function sizeSignals(model, sizeType) {
  var channel = sizeType === 'width' ? 'x' : 'y';
  var size = model.component.layoutSize.get(sizeType);
  if (!size || size === 'merged') {
    return [];
  }
  // Read size signal name from name map, just in case it is the top-level size signal that got renamed.
  var name = model.getSizeSignalRef(sizeType).signal;
  if (size === 'step') {
    var scaleComponent = model.getScaleComponent(channel);
    if (scaleComponent) {
      var type = scaleComponent.get('type');
      var range = scaleComponent.get('range');
      if (hasDiscreteDomain(type) && isVgRangeStep(range)) {
        var scaleName = model.scaleName(channel);
        if (isFacetModel(model.parent)) {
          // If parent is facet and this is an independent scale, return only signal signal
          // as the width/height will be calculated using the cardinality from
          // facet's aggregate rather than reading from scale domain
          var parentResolve = model.parent.component.resolve;
          if (parentResolve.scale[channel] === 'independent') {
            return [stepSignal(scaleName, range)];
          }
        }
        return [stepSignal(scaleName, range), {
          name: name,
          update: sizeExpr(scaleName, scaleComponent, "domain('".concat(scaleName, "').length"))
        }];
      }
    }
    /* istanbul ignore next: Condition should not happen -- only for warning in development. */
    throw new Error('layout size is step although width/height is not step.');
  } else if (size == 'container') {
    var isWidth = name.endsWith('width');
    var expr = isWidth ? 'containerSize()[0]' : 'containerSize()[1]';
    var defaultValue = getViewConfigContinuousSize(model.config.view, isWidth ? 'width' : 'height');
    var safeExpr = "isFinite(".concat(expr, ") ? ").concat(expr, " : ").concat(defaultValue);
    return [{
      name: name,
      init: safeExpr,
      on: [{
        update: safeExpr,
        events: 'window:resize'
      }]
    }];
  } else {
    return [{
      name: name,
      value: size
    }];
  }
}
function stepSignal(scaleName, range) {
  var name = "".concat(scaleName, "_step");
  if (isSignalRef(range.step)) {
    return {
      name: name,
      update: range.step.signal
    };
  } else {
    return {
      name: name,
      value: range.step
    };
  }
}
export function sizeExpr(scaleName, scaleComponent, cardinality) {
  var type = scaleComponent.get('type');
  var padding = scaleComponent.get('padding');
  var paddingOuter = getFirstDefined(scaleComponent.get('paddingOuter'), padding);
  var paddingInner = scaleComponent.get('paddingInner');
  paddingInner = type === 'band' ?
  // only band has real paddingInner
  paddingInner !== undefined ? paddingInner : padding :
  // For point, as calculated in https://github.com/vega/vega-scale/blob/master/src/band.js#L128,
  // it's equivalent to have paddingInner = 1 since there is only n-1 steps between n points.
  1;
  return "bandspace(".concat(cardinality, ", ").concat(signalOrStringValue(paddingInner), ", ").concat(signalOrStringValue(paddingOuter), ") * ").concat(scaleName, "_step");
}